import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import FoulPopupDetails from './FoulPopupDetails.vue'

export const FoulPopup = new PopupBuilder('Foul')
  .appendBody(FoulPopupDetails)
  .build()
